import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CorporateCharterCompanyListItemDto } from '@interfaces/corporate-charter/responses/corporate-charter.response';
import { SharedModule } from '@shared/shared.module';
import { CharterStatusBadgeComponent } from '@features/dashboard/company/corporate-charter/components/charter-status-badge/charter-status-badge.component';
import {
  LEGAL_NATURE_LABEL,
  formatCnpj,
} from '@features/dashboard/company/corporate-charter/corporate-charter.util';

/**
 * Tabela da lista "Societário" (`/dashboard/company/societario`): uma linha por empresa com a situação do contrato
 * social. A linha inteira abre a tela da empresa; "Enviar contrato social" (só em `none`) leva ao Data Room dela.
 * Enquanto carrega, desenha linhas de espera no padrão do Data Room (`data-room/styles/_skeleton.scss`).
 */
@Component({
  selector: 'app-charter-companies-table',
  imports: [SharedModule, CharterStatusBadgeComponent],
  templateUrl: './charter-companies-table.component.html',
  styleUrl: './charter-companies-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharterCompaniesTableComponent {
  readonly items = input<CorporateCharterCompanyListItemDto[]>([]);
  readonly loading = input(false);

  readonly openCompany = output<string>();
  readonly sendCharter = output<string>();

  protected readonly skeletonRows = [0, 1, 2, 3, 4, 5, 6, 7];
  protected readonly natureLabel: Record<string, string> = LEGAL_NATURE_LABEL;
  protected readonly formatCnpj = formatCnpj;

  protected onSend(event: Event, companyId: string): void {
    event.stopPropagation();
    this.sendCharter.emit(companyId);
  }

  protected countLabel(value: number | null | undefined): string {
    return value === null || value === undefined ? '-' : String(value);
  }
}
